"use client";

export { RouteError as default } from "@workspace/observability/browser/next";
